let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8gQKz"), load("ctZCD"), load("7Q0UC"), load("gopxm")]).then(() => parcelRequire('1BKEb'));